import NextImage from 'next/image';
import { useState } from 'react';
import { getUrl } from '~/services/shop/utils';
import { useTranslations } from '~/services/umbraco/hooks';
import { Button } from '~/shared/components/Button/Button';
import { Text } from '~/shared/components/Text';
import { EUGaranModalWrapper, LabelWrapper } from './styled';

interface Props {
    itemNo: string;
}

// Matches the backend label's viewBox (269.29 x 283.46)
const WIDTH = 269;
const HEIGHT = 283;

const EUGaranModal = ({ itemNo }: Props) => {
    const { translate } = useTranslations();
    const [hasError, setHasError] = useState(false);

    return (
        <EUGaranModalWrapper>
            <Text as="h2" variant="display2" >
                {translate('product.euGaran.modalTitle')}
            </Text>
            {hasError ? (
                <Text>{translate('product.euGaran.labelNotFound')}</Text>
            ) : (
                <LabelWrapper>
                    <NextImage
                        src={getUrl(`/eu-guarantee-label/${itemNo}.svg`).toString()}
                        alt="GARAN"
                        width={WIDTH}
                        height={HEIGHT}
                        onError={() => setHasError(true)}
                        unoptimized
                    />
                </LabelWrapper>
            )}

            {hasError ? null : (
                <Button
                    type="button"
                    variant="stroke"
                    noIcon
                    // Opens the PDF in the browser's viewer, which handles printing
                    onClick={() =>
                        window.open(
                            getUrl(`/eu-guarantee-label/${itemNo}.pdf`).toString(),
                            '_blank',
                            'noopener,noreferrer',
                        )
                    }
                >
                    {translate('product.euGaran.print')}
                </Button>
            )}
        </EUGaranModalWrapper>
    );
};

export default EUGaranModal;
